import revive_payload_client_4sVQNw7RlN from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/.nuxt/element-plus-injection.plugin.mjs";
import ssr_plugin_B4ptqVdIfe from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/node_modules/@vueuse/nuxt/ssr-plugin.mjs";
import toast_Zl2rZYKMaV from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/plugins/toast.js";
import global_dY5SAi3BsR from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/plugins/global.js";
import dialog_ochZav95Qu from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/plugins/dialog.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  ssr_plugin_B4ptqVdIfe,
  toast_Zl2rZYKMaV,
  global_dY5SAi3BsR,
  dialog_ochZav95Qu
]